module.exports = __webpack_public_path__ + "img/pos1-bg.a3c6f720.jpg";